import { utcToZonedTime } from "date-fns-tz";
import { inject } from "mobx-react";
import React, { useMemo } from "react";
import type { Store } from "../../../../client/stores";
import { AgentOSType, getOsTypeFromAgent } from "../../../../client/utils";
import { VolumeInCircleIcon } from "../../../core/components/icons/VolumeInCircleIcon.component";
import { ButtonKind, FauxButton } from "../../../core/ui";
import { COAST_SHOW_TYPE } from "../lib/coastContent";
import { CoastShowAudioboxWMPLoader } from "../page-blocks/content/coast-show-audiobox/CoastShowAudioboxWMP.component";

interface CoastOnAirStatusProps {
    isLive: boolean;
    store?: Store;
}

const getTagline = (isLive: boolean, isSIT: boolean) => {
    if (isLive) {
        if (isSIT) {
            return "ON AIR NOW: ART BELL - SOMEWHERE IN TIME";
        }

        return "ON AIR NOW: LISTEN LIVE";
    }

    return "Live Nightly 1am - 5am EST / 10pm - 2am PST";
};

export const CoastOnAirStatus = inject("store")(({ isLive, store }: CoastOnAirStatusProps) => {
    if (!store) {
        return null;
    }

    const nowDate = useMemo(
        () => utcToZonedTime(new Date(), store.site.index.timeZone || store.env.DEFAULT_TIMEZONE),
        [store.env.DEFAULT_TIMEZONE, store.site.index.timeZone],
    );

    const isSomewhereInTimeShow = useMemo(() => {
        return nowDate.getDay() === 6 && nowDate.getHours() >= 18 && nowDate.getHours() < 22;
    }, [nowDate]);

    const tagline = useMemo(() => getTagline(isLive, isSomewhereInTimeShow), [isLive, isSomewhereInTimeShow]);

    const osType = useMemo(() => getOsTypeFromAgent(), []);

    return (
        <div className="component-on-air-status">
            {isLive ? <span className="live-indicator">&bull;</span> : null}

            <span>{tagline}</span>

            {isLive ? (
                <>
                    <FauxButton
                        to="/videos/insider-audio/live/"
                        title="Listen with Coast Player"
                        className="button-listen-live"
                        kind={ButtonKind.CUSTOMIZED}
                    >
                        <VolumeInCircleIcon fill="#fff" />
                    </FauxButton>

                    {osType === AgentOSType.WINDOWS ? (
                        <CoastShowAudioboxWMPLoader
                            showType={
                                isSomewhereInTimeShow ? COAST_SHOW_TYPE.SOMEWHERE_IN_TIME : COAST_SHOW_TYPE.REGULAR
                            }
                            showDate={nowDate}
                            osType={osType}
                        />
                    ) : null}
                </>
            ) : null}
        </div>
    );
});
